export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9216.3db4f32f.jpg";